// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","feedFilter":"_3mSup217DAyXxZgdc7vSye","filterFeedButton":"_2-aMKoafw7Q30glzRw4Gn4","filterFeedSelected":"_2ugHS69DH294OuCe1hPurM"};